module.exports = __webpack_public_path__ + "img/pencil-edit.ee064796.svg";